import { Button, Dialog, DialogBody, DialogFooter, DialogHeader } from '@material-tailwind/react';

const Alert = (props: {
  arrAlertMessage: Array<any>;
  alertHeader: string;
  handleOpen: any;
  isExpanded: boolean;
}) => {
  return (
    <Dialog className="Alert" open={props.isExpanded} handler={props.handleOpen}>
      <DialogHeader className="AlertHeader">{props.alertHeader}</DialogHeader>
      {props.arrAlertMessage.length !== 0 && props.arrAlertMessage[0] !== '' && (
        <DialogBody className="AlertBody" divider>
          <div className="flex flex-col font-normal text-off-black">
            {props.arrAlertMessage.map((message, index) => (
              <div key={`AlertMessage_${index}`} className="whitespace-pre-wrap">
                {message.toString()}
              </div>
            ))}
          </div>
        </DialogBody>
      )}
      <DialogFooter>
        <Button
          variant="gradient"
          color="green"
          onClick={props.handleOpen}
          className="ConfirmAlertButton"
        >
          <span>Confirm</span>
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export default Alert;
